import React, { createContext, useState } from "react"
import { ConfigProvider, notification } from "antd"
import { Global } from "@emotion/react"
import { css, theme } from "twin.macro"
import { Icon } from "@/components/atoms"

export const Context = createContext({ name: "SyncNotification" })

const customStyles = css`
    .sync-notification .sync-notification-notice-wrapper {
        border-radius: 8px;
        border: 1px solid ${theme`colors.gray300`};
        box-shadow: ${theme`boxShadow.lg`};

        .sync-notification-notice {
            padding: 16px 24px;
        }
        .sync-notification-notice-message {
            display: none;
        }
        .sync-notification-notice-description {
            margin-inline-start: 0 !important;
            margin: 0;
        }
    }
`

export default function SyncNotificationProvider({ children }) {
    const [visible, setVisible] = useState(false)
    const [api, contextHolder] = notification.useNotification({
        placement: "bottomLeft",
        duration: 0,
        maxCount: 1,
        prefixCls: "sync-notification"
    })

    const openNotification = (configs) => {
        if (visible) return
        setVisible(true)
        api.info({
            description: (
                <div tw="text-primary center-y gap-4" css={[theme`typo.mmedium`]}>
                    <Icon name="loading" sizes={[75, 40]} color="currentColor" />
                    <span tw="after:(inline-block animate-dotty content-[''])">Synchronising</span>
                </div>
            ),
            closeIcon: null,
            icon: () => null,
            ...configs
        })
    }

    const closeNotification = () => {
        api.destroy()
        setVisible(false)
    }

    return (
        <Context.Provider value={{ visible, openNotification, closeNotification }}>
            {children}
            <ConfigProvider theme={{ components: { Notification: { width: 248 } } }}>
                {contextHolder}
            </ConfigProvider>
            <Global styles={customStyles} />
        </Context.Provider>
    )
}
